<template>
  <div class="container">
    <div class="button-container">
      <el-button type="primary" class="feature-secondary" @click="printPdf()">
        <svg-icon
          icon-class="info"
          class="svg-white-color"
          style="font-size: 18px;"
        />
        Print Labels
      </el-button>
    </div>
    <div class="label-container">
      <div
        class="labels"
        v-for="(slot, index) in slotList"
        :key="'label-' + index"
      >
        <div class="number-container label">
          <h1 class="number">{{ slot.no }}</h1>
        </div>
        <div class="label">
          <div class="graphs">
            <div class="qr-code">
              <img :src="srcList[index]" />
            </div>
            <div class="position-graph">
              <div
                class="section"
                v-for="sectionIndex in sectionNum"
                :key="'section-' + sectionIndex"
                :style="aveHeight"
              >
                <div
                  class="slot"
                  :class="{
                    'occupied-slot':
                      slotList[
                        (sectionIndex - 1) * slotPerSection + slotIndex - 1
                      ].no === slot.no
                  }"
                  v-for="slotIndex in slotPerSection"
                  :key="'section-' + sectionIndex + '-slot-' + slotIndex"
                  :style="aveWidth"
                ></div>
              </div>
            </div>
          </div>
          <div class="tips-container">
            <div></div>
            <div class="tip">Left --> Right</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// utils
// import { downloadPdf } from '@/core/utils/pdf'
import { createStackZPLs, zplPdf } from '@/api/zpl'
// api
import { searchStacks } from '@/api/stack'

const QRCode = require('qrcode')

export default {
  name: 'StackLabelsPage',
  data() {
    return {
      stackNo: this.$route.params.no,
      stack: {},
      slotList: [],
      src: '',
      srcList: []
    }
  },
  methods: {
    async plotLabels() {
      const stackList = await searchStacks({ nos: [this.stackNo] })
      const stack = stackList[0]
      this.$set(this, 'stack', stack)
      // this.slotList = stack.slots
      this.$set(this, 'slotList', stack.slots)
      const srcList = Array(this.slotList.length).fill('')
      for (const [i, slot] of this.slotList.entries()) {
        srcList[i] = await this.getSrc(slot)
      }
      this.$set(this, 'srcList', srcList)
    },
    async getSrc(slot) {
      const src = await QRCode.toDataURL(
        JSON.stringify({
          type: 'Slot',
          id: slot.id,
          no: slot.no
        }),
        {
          margin: 0,
          width: 200,
          height: 200
        }
      )
      return src
    },
    async printPdf() {
      const stackList = await searchStacks({ nos: [this.stackNo] })
      const stack = stackList[0]
      const zpls = createStackZPLs(stack)
      const blob = await zplPdf(zpls)
      const href = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', stack.no + '.pdf') // or any other extension
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(href)
      return [true, '']
    }
  },
  computed: {
    sectionNum() {
      return this.stack.sectionNum
    },
    slotPerSection() {
      return this.stack.slotPerSection
    },
    aveHeight() {
      return `height: calc(100% / ${this.sectionNum})`
    },
    aveWidth() {
      return `width: calc(100% / ${this.slotPerSection})`
    }
  },
  mounted() {
    this.plotLabels()
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.label-container {
  @extend .f-r;

  flex-wrap: wrap;
  gap: 20px;
  margin-top: 10px;

  .labels {
    @extend .f-c;

    gap: 10px;
    border: solid;

    .label {
      //   border: solid;
    }

    .number-container {
      @extend .f-c;

      align-items: center;
      justify-content: start;
      width: 400px;
      height: 250px;
      font-size: 40px;
      color: #000;

      .number {
        width: fit-content;
      }

      h1 {
        margin: 0;
      }
    }

    .graphs {
      @extend .f-r-vc;

      gap: 20px;
      justify-content: space-evenly;
      width: 400px;
      height: 200px;

      .qr-code {
        margin-top: 5px;
      }

      .position-graph {
        @extend .f-c;

        justify-content: space-evenly;
        gap: 0;
        height: 200px;
        width: 200px;
        color: #000;
        border: solid 1.5px;

        .section {
          @extend .f-r;

          justify-content: space-evenly;
          gap: 0;
          flex-grow: 1;

          .slot {
            @extend .f-c-c-c;

            flex-grow: 1;
            box-sizing: border-box;
            border: solid;

            .op-icon {
              font-size: 40px;
            }
          }

          .occupied-slot {
            background-color: #000;
          }
        }
      }
    }
  }
}

.tips-container {
  @extend .f-r-vc;

  justify-content: space-around;
  color: #000;
  font-weight: bold;
}
</style>
